export default __webpack_public_path__ + "static/media/sale.423996b2.svg";